import { IBase } from "src/app/core/models/base";
import { IFailedImport } from "./failed-import";

export interface IImport extends IBase{
    importType: ImportTypesEnum,
    status: ImportStatusEnum,
    failedImports: Array<IFailedImport>
}

export enum ImportTypesEnum {
    Products = 0,
    Devices = 1
}

export enum ImportStatusEnum {
    Pending = 0,
    PartiallyImported = 1,
    CompletelyImported = 2,
    NoneImported = 3,
    Failed = 4
}